import { motion } from "framer-motion";
import React from "react";

//x: 0 will put it center of screen
const animations = {
	initial: { opacity: 0, y: -100 },
	animate: { opacity: 1, y: 0 },
	exit: { opacity: 0, y: 100 },
};

const AnimatedPage = ({ children }) => {
	return (
		<motion.div
			variants={animations}
			initial="initial"
			animate="animate"
			exit="exit"
			transition={{ duration: 0.8 }}
		>
			{children}
		</motion.div>
	);
};

export default AnimatedPage;
